import { PaymentCorrelationApi } from "@app/services/apiServices/PaymentCorrelationApi";
import { SpinnerService } from "@app/services/spinner.service";
import { ErrorHandlerService } from "@app/services/ErrorHandler.service";
import { Inject, Injectable } from "@angular/core";
import { PaymentCorrelationRequest } from "@app/models/PaymentCorrelation";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class PaymentCorrelationService {
    constructor(
        @Inject(PaymentCorrelationApi) private paymentCorrelationApi: PaymentCorrelationApi,
        @Inject(SpinnerService) private spinnerService: SpinnerService,
        @Inject(ErrorHandlerService) private errorHandlerService: ErrorHandlerService,
    ) { }

    createCorrelationId(anonymous: boolean, correlationRequest: PaymentCorrelationRequest) {
        return this.paymentCorrelationApi.createCorrelationId(anonymous, correlationRequest)
            .pipe(
                map(response => {
                    if (!response?.correlationId) {
                        throw new Error('No correlation id returned')
                    }
                    return response.correlationId
                }),
                catchError(error => {
                    this.spinnerService.closeSpinner();
                    this.errorHandlerService.showPaymentErrorDialog(
                        "Request Error",
                        "We encountered an issue while processing your request.",
                        "Please try again later."
                    )
                    return of(null);
                })
            )
    }
}
